import type { ReactNode } from 'react';

import { cn } from '../utils/cn';

interface CipScreenShellProps {
  /** Small uppercase eyebrow label (e.g. "Identity verification"). */
  label?: ReactNode;
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  className?: string;
}

/**
 * Shared panel wrapper for every CIP gallery screen — matches
 * raas-widgets-flow-smart `CipScreenShell` card UX.
 */
export const CipScreenShell = ({
  label,
  title,
  description,
  children,
  className,
}: CipScreenShellProps) => (
  <section
    className={cn(
      'border-border bg-bg-elevated rounded-2xl border p-6',
      className,
    )}
  >
    {label && (
      <p className="text-fg-muted text-[10px] font-semibold uppercase tracking-[0.2em]">
        {label}
      </p>
    )}
    <h2 className="mt-3 text-2xl font-semibold tracking-tight">{title}</h2>
    {description && <p className="text-fg-muted mt-2 text-sm">{description}</p>}
    {children}
  </section>
);

/** Small inline spinner matching the accent token. */
export const CipSpinner = ({ className }: { className?: string }) => (
  <span
    role="status"
    aria-live="polite"
    className={cn(
      'border-border border-t-accent inline-block h-5 w-5 animate-spin rounded-full border-2',
      className,
    )}
  />
);
